/**
 * QuickBooks OAuth connect — matches legacy Invoice page admin flow.
 */

/**
 * Admin QuickBooks connect CTA.
 * BE sends quickbooks_connected. Older responses sent auth_token.token.
 */
export function shouldShowQuickBooksConnect({ role, authToken, quickbooksConnected }) {
  if (role !== 'admin') return false;
  if (typeof quickbooksConnected === 'boolean') return !quickbooksConnected;
  if (!authToken) return true;
  return !authToken.token;
}

export function openQuickBooksOAuthPopup(url) {
  if (!url || typeof window === 'undefined') return null;
  const width = 500;
  const height = 400;
  const left = window.screenX + (window.outerWidth - width) / 2;
  const top = window.screenY + (window.outerHeight - height) / 2.5;
  return window.open(
    url,
    'QuickBooks OAuth',
    `width=${width},height=${height},left=${left},top=${top}`,
  );
}

export function resolveRedirectUrl(redirectURL) {
  if (!redirectURL) return null;
  if (typeof redirectURL === 'string') {
    return redirectURL.startsWith('http') ? redirectURL : null;
  }
  if (typeof redirectURL?.toJS === 'function') {
    const value = redirectURL.toJS();
    return typeof value === 'string' && value.startsWith('http') ? value : null;
  }
  return null;
}
